import { render, staticRenderFns } from "./adminApparatus.vue?vue&type=template&id=5823c1c8"
import script from "./adminApparatus.vue?vue&type=script&lang=js"
export * from "./adminApparatus.vue?vue&type=script&lang=js"
import style0 from "./adminApparatus.vue?vue&type=style&index=0&id=5823c1c8&prod&lang=css"
import style1 from "./adminApparatus.vue?vue&type=style&index=1&id=5823c1c8&prod&slot-scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports